import { debounce } from "@teaming/common-util";

export default {
	data() {
		return {
			windowResizeHandle: null,
			screenWidthHandle: null,
			screenWidth: 0,
			viewportWidth: 0,
			viewportHeight: 0,
			breakpoint: "",
		};
	},
	computed: {
		buttonSize() {
			const { screen, } = this.$foundation();
			const { BREAKPOINTS, } = screen;
			return screen.gteq( this.screenWidth, BREAKPOINTS.MD ) ?
				"SMALL" :
				"MEDIUM";
		},
	},
	created() {
		const { screen, } = this.$foundation();

		this.screenWidthHandle = debounce( width => {
			this.screenWidth = width;
			this.viewportWidth = width;
			this.breakpoint = screen.findBreakpoint( this.viewportWidth );
		}, 100 );

		this.windowResizeHandle = debounce( () => {
			this.viewportHeight = window.document.body.clientHeight;
			this.viewportWidth = window.document.body.clientWidth;
			this.breakpoint = screen.findBreakpoint( this.viewportWidth );
		}, 100 );

		this.screenWidth = window.document.body.clientWidth;
		this.viewportWidth = window.document.body.clientWidth;
		this.viewportHeight = window.document.body.clientHeight;
		this.breakpoint = screen.findBreakpoint( this.viewportWidth );
	},
	mounted() {
		// screen width is used to imperatively set the
		// size of the new key result button, since that
		// is controlled by props and not CSS
		// @see this.keyResultButtonSize
		const { screen, } = this.$foundation();
		screen.on( "widthChange", this.screenWidthHandle );
		window.addEventListener( "resize", this.windowResizeHandle );
	},
	beforeUnmount() {
		const { screen, } = this.$foundation();
		screen.off( "widthChange", this.screenWidthHandle );
		this.screenWidthHandle = null;

		window.removeEventListener( "resize", this.windowResizeHandle );
		this.windowResizeHandle = null;
	},
};
